import { z } from 'zod'
import { AccountDetails } from '@/types'

export const Account = z.object({
  token: z.string(),
  password: z.string(),
  details: AccountDetails
})

export type Account = z.infer<typeof Account>
